import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const MissionSection = () => {
  const [content, setContent] = useState({
    label: "Our Mission",
    title: "Live Long and Prosper",
    description: "The Nimoy-Knight Foundation was established by Leonard Nimoy's daughter Julie Nimoy and filmmaker David Knight to celebrate his remarkable life and share his message of hope, inspiration, and compassion with the world."
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/homepage-content`);
        if (response.data) {
          setContent({
            label: response.data.mission_label || content.label,
            title: response.data.mission_title || content.title,
            description: response.data.mission_description || content.description
          });
        }
      } catch (err) {
        console.log('Using default mission content');
      }
    };
    fetchContent();
  }, []);

  return (
    <section className="py-24 bg-[#0f0f12]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-block px-4 py-2 bg-amber-500/10 text-amber-500 text-sm font-semibold rounded-full mb-6">
          {content.label}
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          {content.title}
        </h2>
        <p className="text-gray-400 text-lg leading-relaxed">
          {content.description}
        </p>
      </div>
    </section>
  );
};

export default MissionSection;
